/* eslint-disable max-lines-per-function, max-lines */
import { EventBus, Events, store } from "jiffy-store";
import { api } from "jiffy-api";
import { sendDataLayer, sendDataLayerOnLinkClickEvent } from "jiffy-analytics";
import { activateIub } from "common/utils/ui/iub-consent-utils";
import deliveryDateFormClass from "common/utils/delivery-date/delivery-date-form-class";
import deliveryLocationClass from "common/utils/delivery-location/delivery-location-class";
import MadeStore from "components/jiffy/vue-product-details-print/store/store";
import idleCallback, { timings } from "common/utils/ui/idle_callback";
import initColorsSlider from "components/jiffy/product-colors-slider/product-colors-slider";
import initColorPalette from "components/jiffy/product-color-palette/product-color-palette";
import initLeftInfo from "components/jiffy/product-details-info-left/product-details-info-left";
import initContinueShoppingModal from "components/jiffy/continue-shopping-modal/continue-shopping-modal";
import initAddedToCartModalV2 from "components/jiffy/added-to-cart-modal-v2/added-to-cart-modal-v2";
import initLightBox from "components/jiffy/product-lightbox/product-lightbox";
import initColorPicker, {
  listenForColorSelect
} from "components/jiffy/product-color-picker/product-color-picker";
import { isMobileBrowser, isBare } from "common/utils/browser";
import initRelatedProducts from "components/jiffy/product-related-products/product-related-products";
import initProductDetailsImageCarousel from "components/jiffy/product-details-image-carousel/product-details-image-carousel";
import initReviewSummary from "components/jiffy/review-summary/review-summary";
import initDeliveryDatePills from "components/jiffy/delivery-date-pill/delivery-date-pill";
import initQuantityForm from "components/jiffy/product-details-quantity-form/product-details-quantity-form";
import initDesktopGridToggle from "components/jiffy/product-desktop-grid-toggle/product-desktop-grid-toggle";
import initProductGrid from "components/jiffy/product-grid/product-grid";
import productPage from "components/jiffy/product-details-quantity-form/product-page";
import initReviews from "components/jiffy/reviews-list/reviews-list";
import setFieldsOnGrids from "components/jiffy/product-details-quantity-form/set-fields-on-grids";
import initValidationModal from "components/jiffy/cart-validation-modal/cart-validation-modal";
import initProductDetailsBulkMobile from "components/jiffy/product-details-bulk-mobile/product-details-bulk-mobile";
import initProductDetailsDtfSheet from "components/jiffy/product-details-dtf-sheet/product-details-dtf-sheet";
import initProductDetailsFeatures from "components/jiffy/product-details-features/product-details-features";
import initProductDetailsHeader from "components/jiffy/product-details-header/product-details-header";
import initProductDetailsTitle from "components/jiffy/product-details-title/product-details-title";
import initJiffyServicesPreview from "components/jiffy/jiffy-services-preview/jiffy-services-preview";
import initPdpMadeReviews from "components/jiffy/pdp-made-reviews/pdp-made-reviews";
import initProductDetailsSummary from "components/jiffy/product-details-summary/product-details-summary";
import initProductDetailsGangSheetDiscount from "components/jiffy/product-details-gang-sheet-discount/product-details-gang-sheet-discount";
import initOtherTransferUpsells from "components/jiffy/upsell-other-transfers/upsell-other-transfers";
import initProductDetailsPrintAb from "components/jiffy/vue-product-details-print-ab/vue-product-details-print";
import initPdpExperienceWarning from "components/jiffy/pdp-experience-warning/pdp-experience-warning";
import initUploadMadeButton from "components/jiffy/product-details/product-details-upload-button/product-details-upload-button";
import initUploadMadeButtonStatic from "components/jiffy/product-details/product-details-upload-button-static/product-details-upload-button-static";
import initProductDeliveryTimeleft from "components/jiffy/product-delivery-timeleft/product-delivery-timeleft";
import initMadeApparelBenefits from "components/made_apparel_benefits/component";
import initSignInModal from "components/jiffy/sign-in-modal/sign-in-modal";
import initProductRequestSample from "components/jiffy/product-request-sample/product-request-sample";
import initDesignUploadPdp from "components/jiffy/design-upload-cta/design-upload-cta-pdp/design-upload-cta-pdp";
import { isCustomizableMadePage } from "components/jiffy/product-details/customizable-made-page-utils";
import {
  isCheckIsFirstTimeVisitor,
  removeTidioChatScript
} from "common/customer/first-time-visitor";
import { initPDP as initProductDetailsBulkDiscountSlider } from "components/jiffy/bulk-discount-slider/bulk-discount-slider";
import ProductEngagementTracker from "./product-engagement-tracker";
import initBackButton from "./product-details-back/product-details-back";
import initInventory from "./inventory";
import setPdpBadges from "./set-pdp-badges";
import loadPrices from "./load-prices";
import "common/customer/redirect_to_help";
import initSampleOrderLimitModal from "./product-details-sample-order-limit-modal/product-details-sample-order-limit-modal";
import "components/jiffy/grid-validation-modal/grid-validation-modal";
import "components/jiffy/product-comments/product-comments";
import "components/jiffy/bulk-discount-toggle-rows/bulk-discount-toggle-rows";
import "components/jiffy/product-details-special-header/product-details-special-header";
import "components/jiffy/product-details-discontinued/product-details-discontinued";
import "components/jiffy/product-details-subtitle/product-details-subtitle";
import "components/jiffy/product-details-brand/product-details-brand";
import "components/jiffy/product-details-user-feedback/product-details-user-feedback";
import "components/jiffy/product-details-badges/product-details-badges";
import "components/jiffy/product-details-badges-carousel/product-details-badges-carousel";
import "components/jiffy/product-details-info-right/product-details-info-right";
import "components/jiffy/product-details-mask-disclaimer/product-details-mask-disclaimer";
import "components/jiffy/product-details-mask-manufacturer-description/product-details-mask-manufacturer-description";
import "components/jiffy/product-details-description/product-details-description";
import "components/jiffy/product-details-description-details/product-details-description-details";
import "components/jiffy/product-details-measurements/product-details-measurements";
import "components/jiffy/product-details-savings/product-details-savings";
import "components/jiffy/product-details-tabbed-info/product-details-tabbed-info";
import "components/jiffy/product-details-video/product-details-video";
import "components/jiffy/product-notes/product-notes";
import "components/jiffy/product-shipping-notes/product-shipping-notes";
import "components/jiffy/product-details-bulk-discount/product-details-bulk-discount.scss";
import "components/jiffy/product-details/product-details-suggested-searches/product-details-suggested-searches";
import "components/jiffy/final-sale-badge/final-sale-badge";
import "components/jiffy/brands/storefront-pdp/storefront-pdp";
import "components/jiffy/gangsheet-builder-additional-details/gangsheet-builder-additional-details";
import "./product-details.scss";

const hideLink = document.querySelector("#product-details__hide-details");
const bulkUiElements = Array.from(
  [
    document.querySelector(".product-details-info-right__bulk_buyers_button"),
    document.querySelector(".product-details__bulk_buyers_button"),
    document.querySelector(".js-product-details-info-left__bulk-discount-toggle"),
    ...document.querySelectorAll(".product-details-bulk-discount")
  ].filter(Boolean)
);
const caseUiElements = Array.from(document.querySelectorAll(".product-details-savings__case"));
const msrpPricesElements = Array.from(
  document.querySelectorAll(".js-product-details-savings-amounts")
);

const initEvents = () => {
  listenForColorSelect(event => {
    const link = event.target.closest(".product-color-picker__item");
    if (link) {
      sendDataLayerOnLinkClickEvent(
        event,
        {
          genericEvent: true,
          eventCategory: "Product page color picker",
          event: "Color click",
          eventLabel: null,
          eventValue: 1
        },
        link
      );
    }
  });

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, () => {
    sendDataLayer({
      genericEvent: true,
      eventCategory: "Product page color picker",
      event: "Color click",
      eventLabel: null,
      eventValue: 1
    });
  });

  EventBus.on(Events.COLOR_PICKER_OPENED, () => {
    sendDataLayer({
      genericEvent: true,
      eventCategory: "Product page color picker",
      event: "Open",
      eventLabel: null,
      eventValue: 1
    });
  });

  EventBus.on(Events.COLOR_PICKER_CLOSED, () => {
    sendDataLayer({
      genericEvent: true,
      eventCategory: "Product page color picker",
      event: "Close",
      eventLabel: null,
      eventValue: 1
    });
  });
};

const highlightColorPickerItem = () => {
  const $activeColorName = document.getElementById("active-color-name");
  if (!$activeColorName) return;

  const highlightedItem = document.querySelector(
    `[data-color='${$activeColorName.value}'].product-color-picker__item`
  );
  highlightedItem.classList.add("product-color-picker__item--active");
};

const initChildrenComponents = () => {
  initContinueShoppingModal();
  // initAddedToCartModalV2 is called from product-details-dtf-sheet.js for DTF products
  if (!document.querySelector(".js-product-details-dtf-sheet")) {
    initAddedToCartModalV2();
  }
  initLeftInfo();
  initLightBox();
  initBackButton();
  initUploadMadeButton().init();
  initUploadMadeButtonStatic().init();
  initRelatedProducts();
  initProductDetailsImageCarousel();
  initColorsSlider();
  initColorPalette();
  initInventory();
  setPdpBadges();
  setFieldsOnGrids();
  initReviews();
  initReviewSummary();
  initValidationModal();
  initProductDetailsSummary();
  initProductDetailsFeatures();
  initOtherTransferUpsells();

  // Always use AB version (experiment winner)
  initProductDetailsPrintAb();

  initProductDetailsTitle();
  initProductDetailsGangSheetDiscount();
};

const bindEvents = () => {
  EventBus.on(Events.ADD_TO_CART, ({ target }) => {
    let numberOfItemsInCart = 0;
    $.each(target.items, (variantId, qty) => {
      numberOfItemsInCart += qty;
    });

    let eventLabel = numberOfItemsInCart;
    if (numberOfItemsInCart === 0) {
      eventLabel = "NullAddToCart";
    }

    sendDataLayer({
      genericEvent: true,
      eventCategory: "AddToCart",
      event: target.eventAction,
      eventValue: eventLabel
    });
  });

  store.ui.changed((_, { data }) => {
    if (!data.shopBy) return;

    msrpPricesElements.forEach(el => el.classList.add(el.dataset.highlightClass));

    setTimeout(() => {
      msrpPricesElements.forEach(el => el.classList.remove(el.dataset.highlightClass));
    }, 1000);

    if (data.shopBy === "case") {
      bulkUiElements.forEach(el => el.classList.add("hidden"));
      caseUiElements.forEach(el => el.classList.remove("hidden"));
      hideLink.click();
    } else {
      bulkUiElements.forEach(el => el.classList.remove("hidden"));
      caseUiElements.forEach(el => el.classList.add("hidden"));
    }
  });
};

const setCsrfTokens = async () => {
  const csrfTokenSelector = "meta[name='csrf-token']";
  const { content: token } = document.head.querySelector(csrfTokenSelector);

  const $favoriteSignInForm = document.querySelector(".js-product-details-favorite-sign-in-form");
  const $restockNotificationForm = document.querySelector(
    ".js-product-details-notify-on-restock-sign-in-form"
  );
  const $quantityForm = document.querySelector(".js-product-details-quantity-form");
  const $favoriteInput = $favoriteSignInForm?.querySelector('input[name="authenticity_token"]');
  const $quantityInput = $quantityForm?.querySelector('input[name="authenticity_token"]');
  const $restockNotificationInput = $restockNotificationForm?.querySelector(
    'input[name="authenticity_token"]'
  );

  $favoriteInput?.setAttribute("value", token);
  $quantityInput?.setAttribute("value", token);
  $restockNotificationInput?.setAttribute("value", token);
};

const fetchDynamicJavascripts = async () => {
  const productId = $('[name="product_id"]').val();
  const colorName = $('[id="active-color-name"]').val();
  if (!productId || !colorName) return;

  const $productDetails = document.querySelector(".js-product-details");

  const params = {
    product_id: productId,
    color_name: colorName,
    experiment_updates: $productDetails.dataset.experimentUpdates,
    experiment_updates_rudderstack: $productDetails.dataset.experimentUpdatesRudderstack,
    made_dedicated_pdp: isCustomizableMadePage(),
    bare: isBare()
  };

  // Always use POST to avoid any potential 413 errors with large experiment data
  const dynamicJavascriptsResponse = await api.product.fetchDynamicJavascriptsPost(params);

  if (dynamicJavascriptsResponse.scripts) {
    const parser = new DOMParser();
    const scripts = parser.parseFromString(dynamicJavascriptsResponse.scripts, "text/html");

    (isBare() || isCheckIsFirstTimeVisitor()) && removeTidioChatScript(scripts);

    // Inject config elements marked with data-inject (e.g. #web-vitals-config, #tidio-chat-script-pack)
    // into the DOM before scripts so the JS packs can find their configuration
    scripts.querySelectorAll("[data-inject]").forEach(el => {
      document.body.appendChild(el.cloneNode(true));
    });

    scripts.querySelectorAll("script").forEach(script => {
      // Skip scripts that are already loaded on the page (e.g. runtime chunk)
      if (script.src && document.querySelector(`script[src="${script.getAttribute("src")}"]`)) {
        return;
      }

      const newScript = document.createElement("script");

      ["async", "dataset", "defer", "id", "onerror", "src", "type", "class"].forEach(attr => {
        if (script[attr]) {
          if (attr === "dataset") {
            Object.entries(script.dataset).forEach(([key, value]) => {
              newScript.dataset[key] = value;
            });
          } else {
            newScript[attr] = script[attr];
          }
        } else if (["onerror", "class"].includes(attr)) {
          const attrValue = script.getAttribute(attr);
          attrValue && newScript.setAttribute(attr, attrValue);
        }
      });

      newScript.textContent = script.text;
      document.body.appendChild(newScript);
    });

    /* eslint-disable no-underscore-dangle */
    activateIub(window._iub);
    /* eslint-enable no-underscore-dangle */
  }
};

// Swap pdp elements from desktop to mobile layout
function applyResponsive() {
  const isDtf = document.querySelector("#product-page-container")?.dataset.isDtf === "true";

  if (isMobileBrowser() || isDtf || isBare()) {
    return;
  }

  function insertAfter(referenceNode, newNode) {
    if (newNode && referenceNode?.nextSibling) {
      referenceNode?.parentNode?.insertBefore(newNode, referenceNode.nextSibling);
    }
  }

  const productImage = document.querySelector(".js-product-lightbox-wrapper");
  const productColorSlider = document.querySelector(".js-product-colors-slider");
  const deliveryDate =
    document.querySelector("#js-product-details-delivery-dates-simple-container") ||
    document.querySelector("#js-made-product-details-delivery-dates-simple-container");
  const quantityFormTitle = document.querySelector(
    ".js-product-details-info-left__quantity-form-title"
  );
  const productDetailsVariantsForm = document.querySelector("#product-details-variants-form");
  const productDetailsVariantsFormFooter = document.querySelector(
    ".js-product-details-variants-form__footer"
  );
  const productDetailsUpsellSection = document.querySelector("#product-details-upsell-section");

  const mobileMedia = window.matchMedia("(min-width: 768px)");

  const desktopHeaderLeft = document.querySelector(".js-product-details-header__left");

  function reflow({ matches }) {
    if (matches) {
      insertAfter(desktopHeaderLeft, productDetailsVariantsFormFooter);
      insertAfter(desktopHeaderLeft, productDetailsUpsellSection);
      insertAfter(desktopHeaderLeft, productDetailsVariantsForm);
      insertAfter(desktopHeaderLeft, quantityFormTitle);
      insertAfter(desktopHeaderLeft, productColorSlider);
      insertAfter(desktopHeaderLeft, deliveryDate);
    } else {
      insertAfter(productImage, productDetailsVariantsFormFooter);
      insertAfter(productImage, productDetailsUpsellSection);
      insertAfter(productImage, productDetailsVariantsForm);
      insertAfter(productImage, quantityFormTitle);
      insertAfter(productImage, deliveryDate);
      insertAfter(productImage, productColorSlider);
    }
  }

  mobileMedia.addEventListener("change", reflow);

  if (!mobileMedia.matches) {
    reflow(mobileMedia);
  }
}

const initJiffyMadeEvents = () => {
  MadeStore.watch(
    state => ({
      pageMode: state.app.mode,
      madeMode: state.app.madeMode
    }),
    ({ pageMode, madeMode }) => {
      loadPrices({ pageMode, madeMode });
    }
  );
};

const $getDeliverySectionNewLook = () => document.querySelector(".js-delivery-section-new-look");

export default () => {
  applyResponsive();
  initEvents();
  initColorPicker();
  setCsrfTokens();

  const pageMode = MadeStore.getters["app/mode"];
  const madeMode = MadeStore.getters["app/madeMode"];
  const $productDetails = document.querySelector(".js-product-details");
  const { itemsInCart } = $productDetails?.dataset || {};
  window.itemsInCart = itemsInCart;

  // Initialize product engagement tracking (10-second tracker)
  const engagementTracker = new ProductEngagementTracker();
  engagementTracker.init();

  initChildrenComponents();
  bindEvents();
  highlightColorPickerItem();
  fetchDynamicJavascripts();
  initProductDetailsBulkMobile();
  initProductDetailsHeader();
  initJiffyServicesPreview();
  initPdpMadeReviews();
  initProductDetailsDtfSheet();
  initPdpExperienceWarning();
  initProductDeliveryTimeleft();
  initJiffyMadeEvents();
  initMadeApparelBenefits();
  initProductRequestSample();
  initSampleOrderLimitModal();
  initDeliveryDatePills();
  initProductDetailsBulkDiscountSlider();
  initSignInModal();
  initDesignUploadPdp();

  idleCallback(() => {
    initQuantityForm();
    productPage.initLineItems();
    loadPrices({ pageMode, madeMode });
  }, timings.quantityForm);

  idleCallback(() => {
    initProductGrid();
    initDesktopGridToggle();
  }, timings.productGrid);

  deliveryDateFormClass().init(true);
  if ($getDeliverySectionNewLook()) {
    deliveryLocationClass();
  }
};
